import { render } from "./BaseTable.vue?vue&type=template&id=ebf80646&scoped=true"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import "./BaseTable.vue?vue&type=style&index=0&id=ebf80646&lang=css"
import "./BaseTable.vue?vue&type=style&index=1&id=ebf80646&scoped=true&lang=css"

import exportComponent from "/var/www/ambientaly/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf80646"]])

export default __exports__